import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';

export interface VisitaRecepcion {
  sesion_id: number; cita_id: number; codigo: string; fecha: string; cliente: string;
  espacio_id: number | null; espacio: string; hora_inicio: string; hora_fin: string | null;
  estado: 'por_llegar' | 'en_uso' | 'finalizada' | 'cancelada'; presentes: number;
  ocupantes: {nombre: string; hora_ingreso: string}[]; ingreso_real: string | null;
  plan: string; unidad: 'hora' | 'dia'; temporizador: boolean;
}

export const fetchRecepcionPOS = (sesion_pos: number, fecha: string): Promise<{fecha:string; visitas:VisitaRecepcion[]}> =>
  handleRequestWithAuth(async () => (await axiosInstance.get('citas/recepcion-pos/', {params:{sesion_pos,fecha}})).data);
